module.exports = __webpack_public_path__ + "img/paris_background.218d4945.jpg";